import { render, staticRenderFns } from "./RealyncLoader.vue?vue&type=template&id=3c436ba2&"
import script from "./RealyncLoader.vue?vue&type=script&lang=js&"
export * from "./RealyncLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports